import { productList } from "./product-list";
import { productForm } from "./product-form";
import { IMPORT_PRODUCTS_XLSX_FR_FR } from "./import-products-xlsx";
import productsTab from "./products-tab.json";

export const products = {
	barMultiSelect: {
		stock: "Stock",
		printerIp: "IP Imprimante",
		addAll: "Ajouter tous",
		removeAll: "Supprimer tous",
	},
	productList,
	productForm,
	importProductsXlsx: IMPORT_PRODUCTS_XLSX_FR_FR,
	productsTab,
};
